import { render } from "./DuplicateSlot.vue?vue&type=template&id=b74472c2&scoped=true"
import script from "./DuplicateSlot.vue?vue&type=script&lang=js"
export * from "./DuplicateSlot.vue?vue&type=script&lang=js"

import "./DuplicateSlot.vue?vue&type=style&index=0&id=b74472c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74472c2"]])

export default __exports__